import { EntityResponseAuditable } from 'src/app/web-api-client';
import { EntityType, ResidencyJurisdiction } from '../../admin/models';

export class Entity {
  entityId?: number;
  clientId?: number;
  clientName?: string;
  residencyJurisdictionId?: number;
  residencyJurisdiction?: ResidencyJurisdiction;
  entityTypeId?: number;
  entityType?: EntityType;
  description?: string | undefined;
  name?: string | undefined;
  isActive?: boolean;
  modified?: Date;

  constructor(entityResponse: EntityResponseAuditable) {
    this.entityId = entityResponse.entityId;
    this.clientId = entityResponse.client?.clientId;
    this.clientName = entityResponse.client?.name;
    this.residencyJurisdictionId = entityResponse.residencyJurisdictionId;
    this.entityTypeId = entityResponse.entityTypeId;
    this.description = entityResponse.description;
    this.name = entityResponse.name;
    this.isActive = entityResponse.isActive;
    this.modified = entityResponse.modified;
  }
}
